import { render, staticRenderFns } from "./RelatorioExportacaoNotasSellin.vue?vue&type=template&id=640ab23e"
import script from "./RelatorioExportacaoNotasSellin.vue?vue&type=script&lang=js"
export * from "./RelatorioExportacaoNotasSellin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports